export default "__VITE_ASSET__12986a5e__"